import { render } from "./ActionButtons.vue?vue&type=template&id=35d4753c&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=35d4753c&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d4753c"]])

export default __exports__